var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4 2C3.44772 2 3 2.44772 3 3V21C3 21.5523 3.44772 22 4 22H16C16.5523 22 17 21.5523 17 21V8L14 2H4Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2V8H20",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 8,
    height: 2,
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 14,
    width: 8,
    height: 2,
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11L10 13L16 7",
    stroke: "#FFC107",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.7e3b71d288071de98cafd12008de21b7.svg";
export { ForwardRef as ReactComponent };